(function(){

  var comp = document.querySelectorAll('.comp-switch-theme');
  if(!comp) return;

  comp.forEach(element => {
    const toggleSwitch = element.querySelector('input[type="checkbox"]');
    const currentTheme = localStorage.getItem('theme');
  
    if(currentTheme) {
      
      document.querySelector('body').dataset.theme = currentTheme;
      if(currentTheme === 'dark') {
        toggleSwitch.checked  = true;
      }
  
    }
    
    function switchTheme(e) {
      
      if(this.checked) {
        document.querySelector('body').dataset.theme = 'dark';
        localStorage.setItem('theme', 'dark');
      }
      else{
        document.querySelector('body').dataset.theme = 'light';
        localStorage.setItem('theme', 'light');
      }    
    }
  
    toggleSwitch.addEventListener('change', switchTheme);
  });
  
})()

jQuery(document).ready(function($) {

  if ($( ".nav-item-dropdown" ).length > 0) {
  
    var navItemsArray = $('.nav-item-dropdown').toArray();
    navItemsArray.shift()
    var navItems = $(navItemsArray); 
    
    navItems.hover(function() {
      $(".overlay-menu").addClass("active")
    })
    navItems.mouseleave(function() {
      $(".overlay-menu").removeClass("active")
    })
  }
  if ($( ".dropdown-trigger-littleWidth" ).length > 0) {
  
    $(".dropdown-trigger-littleWidth").click(function() {
      $(this).nextAll('.dropdown-menu-little-width').slideToggle('fast');
    })
  }
  if ($( ".dropdown-back-littleWidth" ).length > 0) {
  
    $(".dropdown-back-littleWidth").click(function() {
      $(this).closest('.dropdown-menu-little-width').slideToggle('fast');
    })
  }
  
})


